// 七牛图片地址
export const qiniuUploadUrl = 'https://up.qiniup.com'; // 上传时的地址(华东区)
export const qiniuImageURLPrefix = 'https://img.senguo.cc/'; // 访问图片时的域名
export const shopDefault = 'assets/shop_default.png'; // 店铺注册时的默认图片

// 七牛私有空间地址
export const qiniuExportURLPrefix = 'http://export.senguo.cc/'; // 私密库的预览地址